"use client";

import { c as _c } from "react/compiler-runtime";
import { ChevronDoubleLeftIcon } from "@heroicons/react/24/outline";
import Image from "next/image";
import Link from "next/link";
interface WebSidebarHeaderProps {
  readonly collapsed: boolean;
  readonly onToggle: () => void;
}
function WebSidebarHeader(t0) {
  const $ = _c(5);
  const {
    collapsed,
    onToggle
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Link href="/" className="tw-relative tw-z-10 tw-flex tw-items-center tw-ml-3 tw-ease-in-out"><Image unoptimized={true} loading="eager" priority={true} alt="6529Seize" src="/6529.svg" className="tw-h-10 tw-w-10 tw-flex-shrink-0 tw-transition-all tw-duration-100 hover:tw-scale-[1.02] desktop-hover:hover:tw-shadow-[0_0_20px_10px_rgba(255,215,215,0.3)]" width={40} height={40} /></Link>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `desktop-hover:hover:tw-border-iron-600 desktop-hover:hover:tw-bg-iron-700 desktop-hover:hover:tw-shadow-[0_16px_34px_rgba(0,0,0,0.4)] tw-border-iron-700  tw-bg-iron-800 tw-shadow-[0_12px_28px_rgba(0,0,0,0.35)] tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-flex tw-items-center tw-justify-center tw-border tw-border-solid   ${collapsed ? "tw-rotate-180 tw-h-6 tw-w-6 tw-rounded-lg -tw-right-3" : " tw-h-8 tw-w-8 tw-right-4 tw-rounded-xl"}`;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ChevronDoubleLeftIcon strokeWidth={2} className="tw-h-4 tw-w-4 tw-flex-shrink-0 tw-text-iron-200 group-hover:desktop-hover:hover:tw-text-white tw-transition-all tw-duration-300 tw-ease-in-out" />;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== onToggle || $[3] !== t2) {
    t4 = <div className="tw-relative tw-shrink-0 tw-h-12 tw-flex tw-items-center tw-justify-between tw-px-2">{t1}<button type="button" onClick={onToggle} onMouseDown={_temp} className={t2} aria-label="Toggle right sidebar">{t3}</button></div>;
    $[2] = onToggle;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function _temp(event) {
  return event.preventDefault();
}
export default WebSidebarHeader;